import React, { useEffect, useState } from 'react';

import { FLink, Button, FModal, Icons, WideAlert } from '@components';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { toast } from 'react-toastify';
import { format } from 'date-fns';
import { mdiCommentAlertOutline } from '@mdi/js';
import {
  CONTATO_EMPRESTIMO,
  SOLICITACAO_ABSOLUTE_PATH,
  HOME,
} from '../../../../common/utils/paths';
import { EmprestimoService } from '../../../../common/services/emprestimo';

const service = new EmprestimoService();

export const Confirmacao = () => {
  const navigate = useNavigate();
  const { onBack, dtParcelas, dadosBancarios } = useOutletContext();
  const {
    data: { matricula, token } = { matricula: '', token: '' },
    dadosPessoais: {
      logradouro,
      numero,
      cidade,
      estado,
      cep,
      telefone,
      celular,
      cpf,
      complemento,
      bairro,
      nome,
      statusPlano,
    } = {
      logradouro: '',
      numero: '',
      cidade: '',
      estado: '',
      cep: '',
      telefone: '',
      celular: '',
      cpf: '',
      complemento: '',
      bairro: '',
      nome: '',
      statusPlano: '',
    },
  } = useSelector((state) => state.user);
  const patrocinadora = useSelector(
    (state) => state.plan.patrocinadora.data ?? ''
  );
  const {
    simulacao: { valor, parcelas },
    limite: { taxaMes },
  } = useSelector((state) => state.loan);

  const [loadingPDF, setLoadingPDF] = useState(false);
  const [manualMode, setManualMode] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [isEmprestimoEspecial, setIsEmprestimoEspecial] = useState(false);

  const handleGeraPDFsimulacaoEmprestimo = (manual = false) => {
    setLoadingPDF(true);
    const dadosRequest = {
      matricula,
      token,
      nome,
      rua: `${logradouro}-${numero}${complemento && `-${complemento}`}`,
      cidade: `${bairro}-${cep}-${cidade}-${estado}`,
      telefone: `${telefone}${telefone && celular ? ' | ' : ''}${celular}`,
      cpf,
      nParcelas: parcelas,
      taxaJuros: taxaMes.toFixed(4),
      valor,
      banco: dadosBancarios.banco,
      agencia: dadosBancarios.agencia,
      conta: dadosBancarios.conta,
      digito: dadosBancarios.digito,
      situacao: statusPlano,
      empresa: patrocinadora,
      vencPrimeira: format(
        new Date(`${dtParcelas.vencPrimeira} `),
        'dd/MM/yyyy'
      ),
      vencUltima: format(new Date(`${dtParcelas.vencUltima} `), 'dd/MM/yyyy'),
    };
    if (manual) {
      service.gerarPDFSimulacaoEmprestimo(dadosRequest).then((base64) => {
        toast.success(
          'Formulário gerado com sucesso! Favor seguir as instruções descritas na sessão de importante.'
        );
        setLoadingPDF(false);
        const a = document.createElement('a');
        a.href = `data:application/pdf;base64,${base64}`;
        a.download = `Simulação de empréstimo - ${dadosRequest.matricula}.pdf`;
        a.click();
      });
    } else {
      service.gerarPDFSimulacaoEmprestimoSign(dadosRequest).then((res) => {
        if (res.exigirVerificacao === 1) {
          setIsEmprestimoEspecial(true);
          setOpenModal(false);
        } else {
          toast.success(
            'Formulário gerado com sucesso! Favor seguir as instruções descritas na sessão de importante.'
          );
          setLoadingPDF(false);
          const a = document.createElement('a');
          a.href = res.linkAssinatura;
          a.target = '_blank';
          a.click();
          setOpenModal(false);
          navigate(HOME);
        }
      });
    }
  };

  useEffect(() => {
    if (!matricula) return;

    service.validaEmprestimoManual(matricula).then((response) => {
      if (response.AcessoAntigo === 'Sim') {
        setManualMode(true);
      }
    });
  }, [matricula]);

  function handleOpenModal(type) {
    if (type === 'ClickSign') {
      setModalContent('ClickSign');
    } else {
      setModalContent('Manual');
    }
    setOpenModal(true);
  }

  return (
    <>
      <div className="card">
        <div className="card-body">
          <FLink
            className="justify-content-start mb-3 mb-md-32"
            iconLeft="icon-arrow_back"
            onClick={() => onBack(SOLICITACAO_ABSOLUTE_PATH)}
          >
            voltar
          </FLink>
          <h1 className="fw-bold text-black ts-20 mb-2">
            Conclua sua solicitação de empréstimo:
          </h1>

          {!isEmprestimoEspecial ? (
            <div className="wrapper-clicksign">
              <div className="flex-1 clicksign-box">
                <div
                  className={`col-12 ${
                    manualMode ? 'clicksign-description' : 'mb-3'
                  }`}
                >
                  <p className="text-black ts-14 mt-2">
                    Agora a assinatura do contrato de empréstimo da Forluz é
                    digital!{' '}
                    <b>
                      E, para que você tenha uma melhor experiência,
                      recomendamos que esta etapa seja feita pelo APP da Forluz,
                      no seu celular.
                    </b>
                  </p>
                  <p className="text-black ts-14 mt-2">
                    Para prosseguir com a assinatura do contrato, acesse a
                    plataforma e siga o passo a passo. Você passará por
                    validações de segurança e confirmação de informações. Depois
                    de finalizado, o seu requerimento será enviado para análise
                    da Fundação.
                  </p>
                </div>
                <div className="d-flex responsive-flex-button">
                  <button
                    className="w-250 aButton text-center"
                    onClick={() => {
                      handleOpenModal('ClickSign');
                    }}
                  >
                    Acessar a plataforma de assinatura
                  </button>
                </div>
              </div>

              {manualMode && (
                <div className="flex-1 clicksign-box">
                  <div className="col-12 clicksign-description">
                    <p className="text-black ts-16 fw-bold">
                      Imprimir o documento e assinar manualmente:
                    </p>
                    <ol className="text-black ts-14">
                      <li className="mb-1">Baixe o formulário</li>
                      <li className="mb-1">Preencha o formulário</li>
                      <li className="mb-1">Assine a próprio punho</li>
                      <li className="mb-1">Digitalize o formulário assinado</li>
                      <li className="flex-shrink-1">
                        Clique no botão &quot;Enviar formulário&quot; para
                        anexar o arquivo. Ou envie no menu
                        &quot;Requerimentos&quot;, submenu &quot;Solicitação de
                        Empréstimo&quot;
                      </li>
                    </ol>
                  </div>

                  <div className="card-footer d-flex justify-content-center gap-4 responsive-flex-button">
                    <button
                      disabled={loadingPDF}
                      className="aButton text-center"
                      onClick={() => {
                        handleGeraPDFsimulacaoEmprestimo(true);
                      }}
                    >
                      {!loadingPDF
                        ? '01 - Baixar formulários'
                        : 'Carregando...'}
                    </button>

                    <button
                      className="aButton text-center"
                      onClick={() => handleOpenModal('Manual')}
                    >
                      02 - Enviar formulários
                    </button>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <>
              <WideAlert className="mb-4" iconClear={false}>
                <div className="d-block d-lg-flex align-items-center">
                  <Icons
                    path={mdiCommentAlertOutline}
                    color="var(--primary-color)"
                    size={4}
                    style={{ marginRight: 4 }}
                  />
                  <p className="ts-16">
                    <strong>Aviso importante:</strong> Devido a requisitos de
                    segurança, sua trilha de contratação de empréstimo terá que
                    ser finalizada no aplicativo da Forluz que pode ser
                    instalado pelo link abaixo. Após entrar no aplicativo será
                    possivel continuar com a assinatura do ponto onde parou ou
                    então iniciar uma nova simulação.
                    <p>
                      Em caso de dúvidas, entre em contato com a nossa equipe de
                      atendimento (0800 090 9090).
                    </p>
                  </p>
                </div>
              </WideAlert>
              <div className=" d-lg-flex gap-4">
                <Button
                  transparent
                  color="orange"
                  type="submit"
                  onClick={() => {
                    const a = document.createElement('a');
                    a.href =
                      'https://apps.apple.com/br/app/forluz/id1195834897';
                    a.target = '_blank';
                    a.click();
                  }}
                >
                  Ir para a loja do IOS
                </Button>
                <Button
                  transparent
                  color="orange"
                  type="submit"
                  onClick={() => {
                    const a = document.createElement('a');
                    a.href =
                      'https://play.google.com/store/apps/details?id=br.org.forluz.app';
                    a.target = '_blank';
                    a.click();
                  }}
                >
                  Ir para a loja do Android
                </Button>
              </div>
            </>
          )}
        </div>
      </div>

      <FModal
        isOpen={openModal}
        close
        onClose={() => setOpenModal(false)}
        widthAuto
      >
        <div className="col-12">
          <div className="row gap-1">
            <Icons path={mdiCommentAlertOutline} size={3} />
            <p className="col-10 fw-bold ts-20 align-self-center">Atenção</p>
          </div>

          <p className="ts-16 mb-3 p-4 fw-bold background-primary">
            Leia atentamente todas as cláusulas do contrato e o Regulamento de
            Empréstimos Forluz antes de prosseguir. O valor da solicitação
            estará sujeito à confirmação da Forluz. Seu requerimento passará por
            análise interna, e sua confirmação ocorrerá em até 1 dia antes da
            data do crédito
          </p>

          <p className="text-black ts-16 mb-4">
            <b className="primary-color">Atenção:</b> Não assuma compromissos
            financeiros sem a confirmação do crédito em sua conta.
          </p>

          {modalContent === 'ClickSign' ? (
            <div className="overflow-hidden">
              <Button
                disabled={loadingPDF}
                className="w-250 aButton text-center"
                onClick={() => {
                  handleGeraPDFsimulacaoEmprestimo();
                }}
              >
                {!loadingPDF ? 'Assinar meu formulário' : 'Carregando...'}
              </Button>
            </div>
          ) : (
            <FLink
              to={CONTATO_EMPRESTIMO}
              className="w-250 aButton text-center"
              link={false}
              state={{ emprestimo: true }}
            >
              Enviar meu formulário preenchido
            </FLink>
          )}
        </div>
      </FModal>
    </>
  );
};
